import {Image} from "@/entities/Image";
import {renderMarkdown} from "@/utils/markdownHandler";

export default class Product {
  constructor(obj, imgBasePath, hasRowMarkdown = false) {
    this.id = obj.id;
    this.slug = obj.slug;
    this.name = obj.name;
    this.abstract = hasRowMarkdown ? renderMarkdown(obj.abstract) : obj.abstract;
    this.description = hasRowMarkdown ? renderMarkdown(obj.description) : obj.description;
    this.price = obj.price;
    this.specs = hasRowMarkdown ? renderMarkdown(obj.specs) : obj.specs;
    this.img = new Image(obj.img, imgBasePath);
    this.order = obj.Order;
    this.type = obj.Tipo;
    this.isComingSoon = obj.isComingSoon ?? false;
  }
}